import React from "react";
import { GradientButton } from "../UI/GradientButton";
// import { ClientType } from "../../types/form";
// import { isValidClientType } from "../../utils/clientConfig";

interface SuccessStepProps {
  customerEmail: string;
  resetFormData: () => void;
  isEditing: boolean;
  logout: () => void;
}

export const SuccessStep: React.FC<SuccessStepProps> = ({
  customerEmail,
  resetFormData,
  isEditing,
  logout,
}) => {
  const [appLink, setAppLink] = React.useState<string | null>(null);
  // const [clientType, setClientType] = React.useState<ClientType>("Default");
  const [includePaymentStep, setIncludePaymentStep] = React.useState(false);

  React.useEffect(() => {
    setAppLink(localStorage.getItem("appLink"));
    const param = new URLSearchParams(window.location.search);
    // const clientTypeParam = param.get("clientType");
    // if (clientTypeParam && isValidClientType(clientTypeParam)) {
    //   setClientType(clientTypeParam as ClientType);
    // }
    const includePaymentStepParam = param.get("showPayment");
    if (includePaymentStepParam && includePaymentStepParam === "true") {
      setIncludePaymentStep(true);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleReturnHome = () => {
    // Only clear payment status for new profiles, not for editing
    if (!isEditing) {
      localStorage.removeItem("paymentStatus");
      localStorage.removeItem("customerEmail");
      localStorage.removeItem("appLink");
    }
    window.location.href = "/";
    resetFormData();
    logout();
  };

  const handleViewProfile = () => {
    if (appLink) {
      window.open(appLink, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className="form-step active">
      <h2 className="section-title"> {
        isEditing ? "Profile Updated Successfully!" : "Profile Created Successfully!"}</h2>

      {/* Success Header */}
      {includePaymentStep && (
        <div className="text-center mb-8">
          <div className="success-icon mx-auto mb-6">
            <span className="text-4xl">✓</span>
          </div>
          <h1 className="section-title gradient-text">Payment Successful!</h1>
          <p className="text-gray-600 text-lg">
            Thank you for your purchase! Your profile has been created
            successfully.
          </p>
        </div>
      )}

      {/* Account Access Information */}
      {false && (
        <div className="bg-blue-50 border border-blue-200 rounded-2xl p-6 mb-8 display-none">
          <h2 className="text-xl font-bold text-blue-800 mb-4 flex items-center">
            <span className="mr-2">🔐</span>
            Access Your Account
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-3">
              <div className="flex items-center">
                <span className="text-blue-600 mr-3">🌐</span>
                <div>
                  <p className="text-sm font-semibold text-blue-700">Website</p>
                  <p className="text-blue-600">
                    {process.env.REACT_APP_PORTAL_URL}
                  </p>
                </div>
              </div>
              <div className="flex items-center">
                <span className="text-blue-600 mr-3">📧</span>
                <div>
                  <p className="text-sm font-semibold text-blue-700">Email</p>
                  <p className="text-blue-600">{customerEmail}</p>
                </div>
              </div>
              <div className="flex items-center">
                <span className="text-blue-600 mr-3">🔑</span>
                <div>
                  <p className="text-sm font-semibold text-blue-700">
                    Temporary Password
                  </p>
                  <p className="text-blue-600 font-mono">Serenity2@25!</p>
                </div>
              </div>
            </div>
            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
              <div className="flex items-start">
                <span className="text-red-500 mr-2 mt-1">⚠️</span>
                <div>
                  <p className="text-sm font-semibold text-red-700 mb-1">
                    Important
                  </p>
                  <p className="text-sm text-red-600">
                    Please change your password before using the app for
                    security purposes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Profile Link and QR Code */}
      <div className="bg-gray-50 border border-gray-200 rounded-2xl p-6 mb-8">
        <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
          <span className="mr-2">📱</span>
          Share Your Profile
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
          <div>
            <p className="text-gray-600 mb-4">
              Share your professional profile with others using the link below
              or scan the QR code.
            </p>
            <div className="bg-white border border-gray-300 rounded-lg p-3 mb-4">
              <p className="text-sm text-gray-500 mb-1">Profile Link</p>
              <p className="text-sm font-mono text-gray-800 break-all">
                {appLink}
              </p>
            </div>
            <GradientButton onClick={handleViewProfile} variant="primary">
              View My Profile
            </GradientButton>
          </div>
          <div className="text-center">
            <div className="bg-white border border-gray-300 rounded-lg p-4 inline-block">
              <div className="w-32 h-32 bg-gray-100 rounded-lg flex items-center justify-center">
                <span className="text-gray-400">
                  <img
                    src={
                      process.env.REACT_APP_BASE_API_URL +
                      "/api/exhibit/qr?id=" +
                      appLink?.split("/").pop()
                    }
                    alt="QR Code"
                  />
                </span>
              </div>
            </div>
            <p className="text-sm text-gray-500 mt-2">Scan to share</p>
          </div>
        </div>
      </div>

      {/* How's it Going so Far? */}
      <div className="bg-blue-50 border border-blue-200 rounded-2xl p-6 mb-8">
        <h2 className="text-xl font-bold text-blue-800 mb-4 flex items-center">
          <span className="mr-2">⭐</span>
          How's it Going so Far?
        </h2>
        <p className="text-blue-700 mb-4">
          Please let us know about your experience.
        </p>
        <div className="flex items-center justify-center">
          <a
            href="https://forms.viiision.com/252654981507970"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-700 font-semibold flex items-center"
          >
            <span className="mr-2">⭐</span>
            Give Feedback
          </a>
        </div>
      </div>

      {/* Contact Information */}
      <div className="bg-green-50 border border-green-200 rounded-2xl p-6 mb-8">
        <h2 className="text-xl font-bold text-green-800 mb-4 flex items-center">
          <span className="mr-2">💬</span>
          Need Help?
        </h2>
        <p className="text-green-700 mb-4">
          A confirmation email has been sent to <strong>{customerEmail}</strong>
          . If you have any questions or need assistance, please don't hesitate
          to contact us.
        </p>
        <div className="flex items-center justify-center">
          <a
            href="mailto:services@viiision.com"
            className="text-green-600 hover:text-green-700 font-semibold flex items-center"
          >
            <span className="mr-2">📧</span>
            services@viiision.com
          </a>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <GradientButton onClick={handleReturnHome} variant="primary">
          Create New Form
        </GradientButton>
      </div>
    </div>
  );
};
